import {
  CONTACT_EMAIL,
  ORG_NAME,
  ORG_ORIGIN,
  SITE_DESCRIPTION,
  SITE_NAME,
  SITE_ORIGIN,
} from "./site";

const ORG_ID = `${ORG_ORIGIN}/#organization`;
const SITE_ID = `${SITE_ORIGIN}/#website`;

export function webPageLd(path: string, name: string) {
  const url = `${SITE_ORIGIN}${path === "/" ? "/" : path}`;
  const types: Record<string, string> = {
    "/about": "AboutPage",
    "/contact": "ContactPage",
    "/fests": "CollectionPage",
    "/calendar": "WebPage",
  };
  return {
    "@context": "https://schema.org",
    "@type": types[path] ?? "WebPage",
    name,
    url,
    description: SITE_DESCRIPTION,
    isPartOf: { "@id": SITE_ID },
    publisher: {
      "@type": "Organization",
      "@id": ORG_ID,
      name: ORG_NAME,
      url: ORG_ORIGIN,
      email: CONTACT_EMAIL,
    },
  };
}
